import Enum from '../../utilities/enum';

export const DebtCollectionProviderDisplay = ({ debtCollectionProvider, organisationId }) => {
    const debtViewWebhookBaseUrl = `https://api.advancedparking.tech/${ organisationId }/webhooks/debtview`
    const isDebtView = debtCollectionProvider.debtCollectionType === 2
    const isDcbl = debtCollectionProvider.debtCollectionType === 3

    return (
        <div className="card-body bg-light border-top details-container">
            <div className="row">
                <div className="col-md-3 col-12">
                    <p className="font-weight-semi-bold mb-3 mt-1">Name</p>
                </div>
                <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.name }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12">
                    <p className="font-weight-semi-bold mb-3">Default</p>
                </div>
                <div className="col-md-6 col-12 pt-1">
                    { debtCollectionProvider.isDefault && <i className="fas fa-check text-success"></i> }
                    { !debtCollectionProvider.isDefault && <i className="fas fa-times text-danger"></i> }
                </div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12">
                    <p className="font-weight-semi-bold mb-3">Method</p>
                </div>
                <div className="col-md-6 col-12 pt-1">{ Enum.DebtCollectionType[debtCollectionProvider.debtCollectionType] }</div>
            </div>
            {
                isDebtView &&
                <>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Tenant</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewTenant }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Subscription Key</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewSubscriptionKey }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Client Key</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewClientKey }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Username</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewUsername }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Password</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewPassword }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Webhook base URL</p>
                        </div>
                        <div className="col-md-9 col-12 d-flex align-items-start">
                            { debtViewWebhookBaseUrl }
                            <button onClick={ () => navigator.clipboard.writeText(debtViewWebhookBaseUrl) } className="btn p-0 py-1"><i className='fas fa-copy ml-2'></i></button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Webhook API Key</p>
                        </div>
                        <div className="col-md-6 col-12 pt-1">{ debtCollectionProvider.debtViewApiKey }</div>
                    </div>
                </>
            }
            {
                isDcbl &&
                <>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Username</p>
                        </div>
                        <div className="col-md-6 col-12">{ debtCollectionProvider.dcblUsername }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Password</p>
                        </div>
                        <div className="col-md-6 col-12">{ debtCollectionProvider.dcblPassword }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Client Pointer</p>
                        </div>
                        <div className="col-md-6 col-12">{ debtCollectionProvider.dcblClientPointer }</div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-12">
                            <p className="font-weight-semi-bold mb-3">Placement</p>
                        </div>
                        <div className="col-md-6 col-12">{ debtCollectionProvider.dcblPlacement }</div>
                    </div>
                </>
            }
        </div>
    )
}
